'use client';

import { CheckSquareIcon } from '@/shared';

import type { ISupport } from '../../types';

export const Support = ({ items }: { items: ISupport['items'] }) => {
	return (
		<>
			<div className="-m-3 flex snap-x snap-mandatory flex-nowrap gap-4 overflow-x-auto p-3 md:m-0 md:grid md:snap-none md:grid-cols-2 md:overflow-visible md:p-0 xl:gap-4">
				{items.map((content, key) => (
					<dl
						key={key}
						className="flex w-11/12 shrink-0 snap-center flex-row gap-6 rounded-2xl border border-[#DBDFE9] bg-white p-4 md:w-auto md:rounded-3xl md:p-6 2xl:gap-8 2xl:rounded-[40px] 2xl:p-8"
					>
						<dt>
							<CheckSquareIcon className="size-6 xl:size-8" />
						</dt>
						<dd className="text-sm/[1.2] font-semibold text-[#252F4A] xl:text-base/[1.2] 2xl:text-2xl/[1.3]">
							{content}
						</dd>
					</dl>
				))}
			</div>
		</>
	);
};
